import type { Folder } from '../api';

export function folderPath(folder: Folder, folders: Folder[]): string {
  const parts = [folder.name];
  const seen = new Set([folder.id]);
  let parentId = folder.parentId;
  while (parentId && !seen.has(parentId)) {
    seen.add(parentId);
    const parent = folders.find((entry) => entry.id === parentId);
    if (!parent) break;
    parts.unshift(parent.name);
    parentId = parent.parentId;
  }
  return parts.join(' / ');
}

export function folderDescendants(id: string, folders: Folder[]): Set<string> {
  const ids = new Set([id]);
  let added = true;
  while (added) {
    added = false;
    for (const folder of folders) {
      if (folder.parentId && ids.has(folder.parentId) && !ids.has(folder.id)) {
        ids.add(folder.id);
        added = true;
      }
    }
  }
  return ids;
}

/** Keep the original query bytes: signed share URLs must not be rebuilt or normalized. */
export function shareLinks(input: string): string[] {
  const matches = input.match(/https?:\/\/[^\s<>"'\u3000]+/gi) || [];
  return [...new Set(matches.map((value) => value.replace(/[，。；！？、）】》,;!]+$/u, '')))];
}

export function isHttpLink(value: string): boolean {
  try {
    return ['http:', 'https:'].includes(new URL(value).protocol);
  } catch {
    return false;
  }
}
